// Home.js
import React from 'react';
import AppScreenshots from './appScreenshots';
import '../style/home.css';

function Home() {
  return (
    <div className="home-content">
      <h2>Welcome to Oxtor app!</h2>
      <p>Get 24Hr cloud storage and directly share downloadUrl of all uploaded files</p>
      <img src="/images/ic_launcher-playstore.png" alt="Play Store Logo" className="logo" />
      <button
        href="https://play.google.com/store/apps/details?id=teamarmada.oxtor"
        target="_blank"
        rel="noopener noreferrer"
        className="download-button">
        Download
      </button>
      <AppScreenshots />
    </div>
  );
}

export default Home;
